import * as React from 'react';
import { Tooltip } from '@payscale/design';
import './eligibilityTooltip.scss';

export interface IEligibilityTooltip {
    id: string;
    text: string;
}

export class EligibilityTooltip extends React.PureComponent<IEligibilityTooltip> {
    render(): React.ReactNode {
        const { id, text } = this.props;
        return (
            <div className={`eligibility-tooltip eligibility-tooltip--${id} col-sm-6`}>
                <Tooltip
                    className="pxl-text-c8-light"
                    hoverText={text ? text : ''}
                    tooltipText="Ineligible"
                    id={id}
                />
            </div>
        );
    }
}

export default EligibilityTooltip;